import React, { useState } from "react";

import { Menu, MenuItem, MenuProps, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import Button, { Color } from "../../../../../../../../../../components/Form/Button";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    marginTop: theme.spacing(6),
    minWidth: 180,
    fontFamily: "Manrope",
    border: "1px solid #E0E2E7",
    "& .MuiMenu-list": {
      padding: "8px 0",
    },
    "& .MuiMenuItem-root": {
      fontFamily: "Manrope",
      color: "#667085",
      padding: "8px 16px",
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active, &:hover": {
        backgroundColor: "#EDF5FB",
        color: "#308CDB",
      },
    },
  },
}));

interface HeaderActionProps {
  disabled?: boolean;
  onSelect?: (type: string) => void;
}

export const HeaderAction = ({ disabled, onSelect }: HeaderActionProps) => {
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <React.Fragment>
      <Button
        disabled={disabled}
        customColor={Color.SECONDARY}
        endIcon={<MdOutlineKeyboardArrowDown size={16} />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {translate("actions")}
      </Button>

      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        id="composition-menu"
        aria-controls={anchorEl ? "composition-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? "true" : undefined}
        aria-labelledby="composition-button"
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          elevation: 0,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => onSelect?.("location")}>{translate("assignLocation")}</MenuItem>
        <MenuItem onClick={() => onSelect?.("storage_box")}>
          {translate("assignStorageBox")}
        </MenuItem>
      </StyledMenu>
    </React.Fragment>
  );
};
